export default __webpack_public_path__ + "locales/tr/People.json?hash=1bcfb53b8c579f4f32784a157a5d40f2";